import { createTheme } from '@mui/material/styles';

export const mrrTheme = createTheme({
  palette: {
    primary: {
      main: '#003DA6',
      light: '#F5F9FF',
      dark: '#003DA6',
    },
    secondary: {
      main: '#E1251B',
      light: 'rgb(255 255 255/1)',
    },
    background: {
      default: '#F5F9FF',
      paper: '#ffffff',
    },
    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#008000',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#003DA6',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#003DA6',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#003da6',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: 'rgb(255 255 255/1)', //for arrow in button
      priceQuoteBackground: '#F5F9FF',
      ndrpSectionBackground: '#f9fafa',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#003DA6',
          '&:hover': {
            backgroundColor: '#7C140F',
          },
          '&:disabled': {
            backgroundColor: 'rgb(249 250 251/1)',
            borderColor: 'rgb(229 231 235/1)',
            color: 'rgb(209 213 219/1)',
          },
          color: 'rgb(255 255 255/1)',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#003DA6',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#003DA6',
          '&:hover': {
            color: '#003DA6',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
